<template>
  <div>
    <div class="title_1_step text-center">3. Métodos de pago</div>
    <div class="shceduler" v-if="!reservedEnrollment">
      Todas las transacciones se realizarán de manera segura.
    </div>
    <v-row v-if="!reservedEnrollment">
      <div class="grayline"></div>

      <v-col cols="8" xs="8" sm="8" md="6" class="black_text"
        >Costo del curso</v-col
      >
      <v-col cols="4" xs="4" sm="4" md class="black_text text-end"
        >S/
        {{
          defaultSection.course_amount ? calcularMonto.toFixed(2) : ""
        }}</v-col
      >

      <div class="grayline" v-if="defaultSection.book_purchase == 1"></div>

      <v-col
        cols="8"
        xs="8"
        sm="8"
        md="6"
        class="black_text"
        v-if="compraLibro == 1"
      >
        {{
          defaultSection.book
            ? defaultSection.book.book_text
              ? defaultSection.book.book_text
              : ""
            : ""
        }}
      </v-col>
      <v-col
        cols="4"
        xs="4"
        sm="4"
        md="6"
        class="black_text text-end"
        v-if="defaultSection.book_purchase == 1"
      >
        {{
          defaultSection.book.book_currency +
            " " +
            defaultSection.book.book_price
        }}
      </v-col>

      <div class="grayline" v-if="selectedDiscounts.length"></div>

      <v-col
        cols="12"
        xs="9"
        sm="9"
        md="9"
        class="black_text"
        v-if="selectedDiscounts.length"
      >
        Descuentos
        <v-icon color="primary" small @click="summary = true">help</v-icon>

        <div v-for="(item, index) in selectedDiscounts" :key="index">
          <div
            class="discount_name_2"
            v-if="item.selected"
            :class="!item.status ? 'discount_remove' : ''"
          >
            <span>{{ item.discount_name + " " + item.percentage_symbol }}</span>
          </div>
        </div>
      </v-col>

      <v-col
        cols="12"
        xs="3"
        sm="3"
        md="3"
        class="black_text text-end"
        v-if="selectedDiscounts.length"
      >
        - S/ {{ grossDiscount }}
        <div v-for="(item, index) in selectedDiscounts" :key="index">
          <div
            class="discount_name_2 discount_value"
            v-if="item.selected"
            :class="!item.status ? 'discount_remove' : ''"
          >
            - S/ {{ item.discount }}
          </div>
        </div>
      </v-col>

      <div class="grayline"></div>
      <v-col cols="8" xs="8" sm="8" md="9" class="greeb_text"
        >Total a pagar</v-col
      >
      <v-col cols="4" xs="4" sm="4" md="3" class="greeb_text text-end">
        S/ {{ totaToPay }}
      </v-col>

      <div class="grayline" v-if="!onlyQuota"></div>
      <v-col cols="8" xs="8" sm="8" md="8" class="black_text" v-if="!onlyQuota"
        >¿Quieres hacer un pago parcial?</v-col
      >
      <v-col
        cols="4"
        xs="4"
        sm="4"
        md="4"
        v-if="!onlyQuota"
        style="display: flex;align-items: flex-end; justify-content: flex-end;"
      >
        <v-switch inset style="margin-top:0px" v-model="feeSwitch"></v-switch>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="gray_text"
        v-if="feeSwitch && !onlyQuota"
        >Selecciona las cuotas que deseas pagar.</v-col
      >

      <div v-if="feeSwitch && !onlyQuota" class="cuotas_card">
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="6"
          class="center_cuotas"
          v-for="(item, index) in feeList"
          :key="index"
        >
          <div
            class="card_cuotas"
            :class="
              item.checked == true ? 'card_cuotas_blue' : 'card_cuotas_gray'
            "
            @click="item.checked = feeSelection(item.checked, index)"
          >
            <img
              class="position_cuota"
              src="./../assets/images/gray_check.svg"
              alt
              v-if="!item.checked && item.last"
            />
            <img
              class="position_cuota"
              src="./../assets/images/blue_check.svg"
              alt
              v-if="item.checked"
            />
            <div
              class="gray_text text-center"
              style="font-weight:bold !important"
            >
              {{ item.description }}
            </div>
            <div class="black_text text-center">{{ "S/ " + item.amount }}</div>
            <div class="gray_text text-center">
              Vence el {{ item.expiration_date }}
            </div>
          </div>
        </v-col>
      </div>

      <v-col
        cols="8"
        xs="8"
        sm="8"
        md="9"
        class="black_text"
        style="margin-top:20px"
        >Deseo Factura como comprobante de pago</v-col
      >
      <v-col
        cols="4"
        xs="4"
        sm="4"
        md="3"
        style="display: flex;align-items: flex-end; justify-content: flex-end;margin-top:20px"
      >
        <v-switch
          inset
          style="margin-top:0px"
          v-model="invoiceSwitch"
          @change="openModal($event)"
        ></v-switch>
      </v-col>

      <v-col cols="12" xs="6" sm="6" md="6" lg="6" v-if="invoiceSwitch">
        <v-text-field
          filled
          label="RUC"
          type="number"
          maxlength="11"
          v-model="invoice_ruc"
          :rules="[rules.required, rules.counter]"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" xs="6" sm="6" md="6" lg="6" v-if="invoiceSwitch">
        <v-text-field
          filled
          label="Razón social"
          v-model="invoice_name"
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" xs="6" sm="6" md="6" lg="6" v-if="invoiceSwitch">
        <v-text-field
          filled
          label="Correo electrónico"
          v-model="invoice_email"
          :rules="[rules.required, rules.email]"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" xs="6" sm="6" md="6" lg="6" v-if="invoiceSwitch">
        <v-text-field
          filled
          label="Dirección legal"
          v-model="invoice_address"
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>

      <!-- METODOS DE PAGO  -->
      <div class="blue_container" style="margin-top:20px;padding: 10px 40px;">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12">
            <div class="black_text">Seleccione el método de pago.</div>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12">
            <v-radio-group
              v-model="radios"
              :mandatory="false"
              style="width:100%"
            >
              <v-radio
                color="black"
                label="Tarjeta de crédito o débito"
                value="radio-1"
              ></v-radio>

              <div class="grayline"></div>

              <v-card-text style="padding:0" v-show="radios == 'radio-1'">
                <form>
                  <v-row>
                    <v-col cols="12" xs="12" sm="12" md="6" v-if="loading">
                      <v-skeleton-loader
                        class="list-item"
                        style="width:100%"
                        :loading="loading"
                        :transition="transition"
                        height="40"
                        type="button"
                      ></v-skeleton-loader>
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="6" v-if="loading">
                      <v-skeleton-loader
                        class="list-item"
                        style="width:100%"
                        :loading="loading"
                        :transition="transition"
                        height="40"
                        type="button"
                      ></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6" v-if="loading">
                      <v-skeleton-loader
                        class="list-item"
                        style="width:100%"
                        :loading="loading"
                        :transition="transition"
                        height="40"
                        type="button"
                      ></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6" v-if="loading">
                      <v-skeleton-loader
                        class="list-item"
                        style="width:100%"
                        :loading="loading"
                        :transition="transition"
                        height="40"
                        type="button"
                      ></v-skeleton-loader>
                    </v-col>
                  </v-row>
                </form>
                <div id="myPaymentForm" v-show="!loading"></div>
                <div
                  class="grayline"
                  style="position: relative;bottom: 15px;"
                ></div>
              </v-card-text>
              <v-radio
                color="black"
                label="Pago en banca por internet o agencia"
                value="radio-2"
              ></v-radio>
              <v-card-text v-if="radios == 'radio-2'">
                <v-row>
                  <v-col cols="6" xs="6" sm="3" md="3">
                    <img src="@/assets/images/LogoBCP.png" alt />
                  </v-col>
                  <v-col cols="6" xs="6" sm="3" md="3">
                    <img src="@/assets/images/Logointerbank.png" alt />
                  </v-col>
                  <v-col cols="6" xs="6" sm="3" md="3">
                    <img src="@/assets/images/logobbva.png" alt />
                  </v-col>
                  <v-col cols="6" xs="6" sm="3" md="3">
                    <img src="@/assets/images/Logo_Scotiabank.png" alt />
                  </v-col>
                </v-row>

                <ul class="bank_payment">
                  <li>
                    Realiza el pago con tu DNI a través de tu banca por
                    internet, app móvil o cualquier agencia autorizada de (BCP,
                    Interbank, BBVA y Scotiabank).
                  </li>
                  <li>
                    La confirmación del pago te la enviaremos al correo
                    electrónico {{ user.email }}
                  </li>
                </ul>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  class="text-center"
                  style="0px 0 25px 0;display: flex;justify-content: center;"
                >
                  <v-btn
                    :class="loading ? 'locked_button' : ''"
                    color="primary"
                    class="btn-basic uppercase"
                    :loading="loading"
                    @click="prepareBankPay()"
                    >Continuar</v-btn
                  >
                </v-col>
              </v-card-text>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
      ></v-col>

      <v-row>
        <v-col cols="6" xs="6" sm="6" md="6" class="flex-startt">
          <div class="return_step_top">
            <span class="selected" @click="goToStep(2)" v-if="!isMinor">
              <v-icon style="cursor:pointer">keyboard_arrow_left</v-icon
              >Anterior
            </span>
            <span class="selected" @click="goToStep(3)" v-if="isMinor">
              <v-icon style="cursor:pointer">keyboard_arrow_left</v-icon
              >Anterior
            </span>
          </div>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="6"
          class="text-end d-flex justify-end align-center"
        >
        </v-col>
      </v-row>
      <!-- FIN DE METODOS DE PAGO -->
    </v-row>

    <v-dialog
      v-model="dialogNoInvoice"
      persistent
      content-class="dialogNoInvoice"
      width="500"
    >
      <v-card>
        <v-card-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialogNoInvoice = radios = null">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="black_text">
          Datos de Factura
        </v-card-text>
        <v-card-text class="dialog_text">
          Debe ingresar los datos solicitados para la emisión de factura.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogNoFee"
      persistent
      content-class="dialogNoFee"
      width="500"
    >
      <v-card>
        <v-card-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialogNoFee = radios = null">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text
          style="display: flex;justify-content: center;"
          class="black_text"
        >
          ¿Quieres hacer un pago parcial?
        </v-card-text>
        <v-card-text class="dialog_text">
          Selecciona la cuota que deseas pagar.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="summary" content-class="summary" width="500">
      <v-card>
        <v-card-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="summary = false">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="black_text dialog_discuont_title">
          Descuentos aplicados
        </v-card-text>
        <v-card-text class="card_discounts__body">
          <div class="dialog_discuont_applied" v-if="selectedCourseDiscount">
            {{ selectedCourseDiscount.percentage }}%
            {{ selectedCourseDiscount.discount_name }}
          </div>
          <div
            class="dialog_discount_text mb-5 mt-3"
            v-if="selectedCourseDiscount"
          >
            Le estamos aplicando el mayor descuento.
          </div>
          <div
            v-for="(item, index) in courseDiscounts()"
            :key="index"
            class="card_discounts__content"
          >
            <img
              class="card_discounts__checked_discount"
              src="@/assets/images/bluecheck.svg"
              v-if="item.selected"
            />
            <span v-else style="width:10px;heigth:8px"></span>
            <span
              class="dialog_discount_name"
              :class="verifySelectedDiscount(item.selected)"
              >{{ item.percentage }}% {{ item.discount_name }}</span
            >
          </div>
          <div
            class="dialog_discount_text mt-5"
            v-if="selectedCourseDiscount && selectedCourseDiscount.detail"
          >
            {{ selectedCourseDiscount.detail }}
          </div>

          <div
            class="dialog_discuont_applied mt-12"
            v-if="selectedBookDiscount"
          >
            {{ selectedBookDiscount.percentage }}%
            {{ selectedBookDiscount.discount_name }}
          </div>

          <div
            class="dialog_discount_text mt-3"
            v-if="selectedBookDiscount && selectedBookDiscount.detail"
          >
            {{ selectedBookDiscount.detail }}
          </div>

          <div class="dialog_discuont_applied mt-12" v-if="selectedAddtional">
            {{ selectedAddtional.percentage }}%
            {{ selectedAddtional.discount_name }}
          </div>

          <div
            class="dialog_discount_text mt-3"
            v-if="selectedAddtional && selectedAddtional.detail"
          >
            {{ selectedAddtional.detail }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import KRGlue from "@lyracom/embedded-form-glue";
import axios from "../axios-auth";
import {
  required,
  maxLength,
  minLength,
  numeric,
  email
} from "vuelidate/lib/validators";
import Helpers from "@/helpers";

export default {
  name: "payment",
  data() {
    return {
      reservedEnrollment: false,
      showMenu: false,
      feeSwitch: false,
      invoiceSwitch: false,
      feeList: [],
      radios: null,
      feeQty: 0,
      user: null,
      loading: true,
      transition: "scale-transition",
      invoice_ruc: "",
      invoice_name: "",
      invoice_address: "",
      invoice_email: "",
      dialogNoInvoice: false,
      dialogNoFee: false,
      krForm: null,
      rules: {
        required: value => !!value || "Campo obligatorio.",
        counter: value => value.length <= 11 || "Ingrese 11 dígitos",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Formato de email incorrecto.";
        }
      },
      ruc: "",
      summary: false
    };
  },

  props: ["step", "isMinor"],

  validations() {
    return {
      invoice_ruc: {
        required,
        numeric,
        maxLength: maxLength(11),
        minLength: minLength(11)
      },
      invoice_name: {
        required
      },
      invoice_address: {
        required
      },
      invoice_email: {
        required,
        email
      }
    };
  },

  created() {
    this.user = this.$store.state.usuario;
  },
  mounted() {
    this.enviarEvento();
  },
  methods: {
    ...mapMutations([
      "addPropToDefaultSection",
      "setDiscountsNuevo",
      "setTotalToPay",
      "setDiscountsList"
    ]),
    ...mapActions(["getTokenPayzen", "bankPayment"]),
    enviarEvento() {
      if (typeof window.gtag === 'function') {
        window.gtag('event', '3 - Métodos de pago', {
          'event_category': 'Matricula'
        });
      }
    },
    invoceValidate() {
      if (
        this.$v.invoice_ruc.$invalid ||
        this.$v.invoice_name.$invalid ||
        this.$v.invoice_email.$invalid ||
        this.$v.invoice_address.$invalid
      ) {
        return true;
      } else return false;
    },

    verifySelectedDiscount(discount_main) {
      if (discount_main) {
        return "discounts_selected";
      } else return "";
    },
    loadFee() {
      let discount = 0;

      this.selectedDiscounts.forEach(element => {
        if (
          element["selected"] &&
          element["quotas_payment"] != "NO" &&
          element["discount_type"] == "PORCENTAJE" &&
          element["item"] == "DERECHOENSEÑANZA"
        ) {
          discount += Number(element["percentage"]);
        }
      });

      discount = Number(discount);

      if (this.defaultSection.quotas && this.defaultSection.quotas.length > 0) {
        this.feeList = this.defaultSection.quotas.map(fee => {
          return {
            amount: discount
              ? Helpers.precise_round(
                  fee.amount - (discount * fee.amount) / 100,
                  2
                )
              : Helpers.precise_round(fee.amount, 2),
            /* amount: fee.amount,  */
            description: fee.description,
            quota_id: fee.quota_id,
            currency: fee.currency,
            expiration_date: fee.expiration_date,
            checked: false
          };
        });

        if (this.feeList.length > 1) {
          this.feeList[0].checked = true;
        }

        if (this.feeList.length > 0) {
          this.feeList[this.feeList.length - 1].last = true;
        }
      }
    },
    feeSelection(checked, index) {
      this.radios = null;

      if (index == this.feeList.length - 1) {
        return checked;
      }

      if (!checked) {
        if (index > 0) {
          if (this.feeList[index - 1].checked) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        if (index < this.feeList.length - 1 || index == 0) {
          if (this.feeList[index + 1].checked) {
            return true;
          } else {
            return false;
          }
        } else {
          return !checked;
        }
      }
    },

    openFactura() {
      this.dialog = true;
    },
    openModal(conditional) {
      if (!conditional) {
        this.openFactura();
      }
    },
    goToStep(n) {
      this.$emit("goToStep", n);
    },
    prepareFee() {
      if (this.feeSwitch) {
        this.feeQty = 0;

        for (var i = 0; i < this.feeList.length; i++) {
          if (this.feeList[i].checked) this.feeQty++;
        }
      }

      /* if(this.defaultSection.quotas){
                this.addPropToDefaultSection({expiration_date: this.defaultSection.quotas[0].expiration_date});
            }  */
    },
    async prepareCardPayment() {
      if (this.invoiceSwitch && this.invoceValidate()) {
        this.dialogNoInvoice = true;
        return;
      } else {
        this.prepareFee();

        if (this.feeSwitch && this.feeQty == 0) {
          this.loading = true;
          this.feeQty = 0;
          this.dialogNoFee = true;
          return;
        } else {
          var instancia = this;
          this.loading = true;

          var enrollment = {
            section_id: this.defaultSection.section_id,
            curriculum_id: this.defaultSection.curriculum_id,
            bill_type: this.invoceValidate() ? "03" : "01",
            quotas_number: this.feeQty == 0 ? 1 : this.feeList.length,
            quotas_payed: this.feeQty == 0 ? 1 : this.feeQty,
            student_data: {
              document_type: this.user.document_type,
              document_number: this.user.document_number,
              email: this.user.email,
              first_name: this.user.first_name,
              second_name: this.user.second_name,
              first_lastname: this.user.first_surname,
              second_lastname: this.user.second_surname
            },
            ruc_data: this.invoceValidate()
              ? null
              : {
                  ruc: this.invoice_ruc,
                  business_name: this.invoice_name,
                  business_address: this.invoice_address,
                  email: this.invoice_email
                },
            book_payment:
              this.defaultSection.book_purchase == "1" ? true : false
          };

          await this.getTokenPayzen(enrollment);

          if (this.krForm && this.krForm.KR != null) {
            this.krForm.KR.setFormConfig({
              formToken: this.tokenPayzen
            });
            this.loading = false;
          } else {
            this.krForm = await KRGlue.loadLibrary(
              process.env.VUE_APP_PAYZEN_END_POINT,
              process.env.VUE_APP_PAYZEN_PUBLIC_KEY
            )
              .then(({ KR }) =>
                KR.setFormConfig({
                  formToken: this.tokenPayzen,
                  "kr-language": "es-ES",
                  "kr-theme": "material"
                })
              )
              .then(({ KR }) => KR.addForm("#myPaymentForm"))
              .then(
                ({ KR, result }) => KR.showForm(result.formId),
                (instancia.loading = false)
              )
              .then(({ KR }) =>
                KR.onSubmit(function(event) {
                  instancia.success(event.clientAnswer);
                  return true;
                })
              )
              .catch(e => {
                console.error(e);
              });
          }
        }
      }
    },
    async success(clientAnswer) {
      if (clientAnswer && clientAnswer.orderStatus == "PAID") {
        let paid = {
          amount: Helpers.precise_round(
            clientAnswer.orderDetails.orderTotalAmount / 100,
            2
          ),
          serverDate: clientAnswer.serverDate,
          cardBrand:
            clientAnswer.transactions[0].transactionDetails.cardDetails
              .effectiveBrand,
          transactionId:
            clientAnswer.transactions[0].transactionDetails.cardDetails
              .legacyTransId
        };
        this.addPropToDefaultSection({ payzen: paid });
        this.addPropToDefaultSection({ paymentType: "card" });

        await this.saveInformationBook();
        this.sendMailing("card");
        this.goToStep(4);
      } else {
        //alert("no se procesó el pago");
      }
    },

    selectedDiscount() {
      if (this.defaultSection) {
        if (this.defaultSection.discounts) {
          let i = -1;
          for (
            let index = 0;
            index < this.defaultSection.discounts.length;
            index++
          ) {
            if (this.defaultSection.discounts[index].discount_main) {
              i = index;
            }
          }
          if (i > -1) {
            return this.defaultSection.discounts[i];
          } else return null;
        } else return null;
      } else return null;
    },
    async prepareBankPay() {
      if (this.invoiceSwitch && this.invoceValidate()) {
        this.dialogNoInvoice = true;
        return;
      } else {
        this.loading = true;
        this.prepareFee();

        if (this.feeSwitch && this.feeQty == 0) {
          this.dialogNoFee = true;
          return;
        } else {
          var enrollment = {
            section_id: this.defaultSection.section_id,
            curriculum_id: this.defaultSection.curriculum_id,
            bill_type: this.invoceValidate() ? "03" : "01",
            quotas_number: this.feeQty == 0 ? 1 : this.feeList.length,
            quotas_payed: this.feeQty == 0 ? 1 : this.feeQty,
            language: "ES",
            currency: "PEN",
            student_data: {
              document_type: this.user.document_type,
              document_number: this.user.document_number,
              email: this.user.email,
              first_name: this.user.first_name,
              second_name: this.user.second_name,
              first_lastname: this.user.first_surname,
              second_lastname: this.user.second_surname
            },
            ruc_data: this.invoceValidate()
              ? null
              : {
                  ruc: this.invoice_ruc,
                  business_name: this.invoice_name,
                  business_address: this.invoice_address,
                  email: this.invoice_email
                },
            book_payment:
              this.defaultSection.book_purchase == "1" ? true : false
          };

          await this.bankPayment(enrollment);

          if (this.bankPay) {
            this.loading = false;
            this.addPropToDefaultSection({ paymentType: "bank" });

            if (this.defaultSection.quotas) {
              this.addPropToDefaultSection({
                expiration_date: this.defaultSection.quotas[0].expiration_date
              });
            }
            
            await this.saveInformationBook();
            this.sendMailing("bank");
            this.goToStep(4);
          }
        }
      }
    },
    calculeAmount() {
      let amount = 0;

      if (this.feeSwitch) {
        for (var i = 0; i < this.feeList.length; i++) {
          if (this.feeList[i].checked)
            amount += parseFloat(this.feeList[i].amount);
        }
      }

      if (amount == 0) {
        amount =
          parseFloat(this.defaultSection.course_amount) -
          parseFloat(this.defaultSection.total_discount);
      }

      if (
        this.defaultSection.book_purchase &&
        this.defaultSection.book.book_price
      ) {
        amount += parseFloat(this.defaultSection.book.book_price);
      }

      return Helpers.precise_round(amount, 2);
    },
    sendMailing(messageType) {
      if (this.defaultSection) {
        if (messageType == "bank") {
          let date = new Date();

          let enrollment = {
            transaction: "",
            name: this.user.first_name,
            course_code: this.defaultSection.course_code,
            course_name: this.defaultSection.course_name,
            email: this.user.email,
            amount: this.calculeAmount(),
            code_alumn: this.user.student_code,
            transaction_date:
              date.getDate() +
              "/" +
              (date.getMonth() + 1) +
              "/" +
              date.getFullYear() +
              " " +
              date.getHours() +
              ":" +
              date.getMinutes() +
              ":" +
              date.getSeconds(),
            card_brand: "",
            campus_name: this.defaultSection.campus_name,
            campus_address: this.defaultSection.campus_address,
            modality_name: this.defaultSection.modality_name,
            frequency_name: this.defaultSection.frequency,
            schedule_name: this.defaultSection.schedule,
            start_end_date_name: this.defaultSection.start_end_date,
            recovery_lessons:
              this.defaultSection.free_days &&
              this.defaultSection.free_days.length > 0
                ? this.defaultSection.free_days.map(day => {
                    return (
                      day.day +
                      " " +
                      day.date +
                      " " +
                      day.start_hour +
                      " - " +
                      day.end_hour
                    );
                  })
                : null,
            book_message:
              this.defaultSection.book && this.defaultSection.book.book_message
                ? this.defaultSection.book.book_message
                : "",
            payment_end_date: this.defaultSection.expiration_date
          };
          axios({
            method: "post",
            url: `users/send-mail-payment-required/`,
            headers: {
              Authorization: "Token " + this.user.token
            },
            data: enrollment
          });
        } else {
          let enrollment = {
            transaction:
              this.defaultSection.payzen &&
              this.defaultSection.payzen.transactionId
                ? this.defaultSection.payzen.transactionId
                : "-",
            course_code: this.defaultSection.course_code,
            course_name: this.defaultSection.course_name,
            email: this.user.email,
            amount:
              this.defaultSection.payzen && this.defaultSection.payzen.amount
                ? this.defaultSection.payzen.amount
                : " - ",
            transaction_date:
              this.defaultSection.payzen &&
              this.defaultSection.payzen.serverDate
                ? this.payDay(this.defaultSection.payzen.serverDate)
                : "",
            card_brand:
              this.defaultSection.payzen && this.defaultSection.payzen.cardBrand
                ? this.defaultSection.payzen.cardBrand
                : " - ",
            campus_name: this.defaultSection.campus_name,
            campus_address: this.defaultSection.campus_address,
            modality_name: this.defaultSection.modality_name,
            frequency_name: this.defaultSection.frequency,
            schedule_name: this.defaultSection.schedule,
            start_end_date_name: this.defaultSection.start_end_date,
            recovery_lessons:
              this.defaultSection.free_days &&
              this.defaultSection.free_days.length > 0
                ? this.defaultSection.free_days.map(day => {
                    return (
                      day.day +
                      " " +
                      day.date +
                      " " +
                      day.start_hour +
                      " - " +
                      day.end_hour
                    );
                  })
                : null,
            book_message:
              this.defaultSection.book && this.defaultSection.book.book_message
                ? this.defaultSection.book.book_message
                : ""
          };
          axios({
            method: "post",
            url: `users/send-mail-success-inscription/`,
            data: enrollment,
            headers: {
              Authorization: "Token " + this.user.token
            }
          });
        }
      }
    },

    async saveInformationBook() {

      let payloadBook = {
        student_code: this.user.student_code,
        application_id: 0,
        section_id: 0,
        campus_id: "-",
        campus_name: "-",
        method_address_book: "-",
        district_id: 0,
        address_book: "-",
        flag: '1',
      };

      // Si la sección tiene compra de libro
      if (this.defaultSection.book_purchase == 1) {
        const application_id = await this.getApplicationId(0);

        let districtId = this.defaultSection.district_id;

        if (districtId != 0) {
          if (!isNaN(districtId)) {
              districtId = Number(districtId);
          }
        }

        payloadBook = {
          student_code: this.user.student_code,
          application_id: application_id ? Number(application_id) : null,
          section_id: this.defaultSection.section_id ? Number(this.defaultSection.section_id) : null,
          campus_id: this.defaultSection.campus.campus_id,
          campus_name: this.defaultSection.campus.campus_name.trim(),
          method_address_book: this.defaultSection.method_address_book,
          district_id: districtId,
          address_book: this.defaultSection.address_book,
          flag: '0',
        }
      }

      await axios({
        method: "post",
        url: `users/book-payment/`,
        headers: {
          Authorization: "Token " + this.user.token,
        },
        data: payloadBook
      });
    },

    async getApplicationId(id) {
      const obj = {
        user_id: this.user.username,
        postulation_id: id
      };

      const response = await axios
        .post(`users/list-postulation/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          return response.data.detail[0].id;
        })
        .catch(err => {
          console.error(err);
        });

      return response;
    },

    payDay(str) {
      let date = new Date(str);
      return (
        date.getDate() +
        "/" +
        (date.getMonth() + 1) +
        "/" +
        date.getFullYear() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
      );
    },
    calculeTotalAmount() {
      let discount = 0;
      let total = 0;

      if (this.selectedDiscounts) {
        this.selectedDiscounts.forEach(element => {
          if (element["status"] && element["selected"]) {
            discount += parseFloat(element["discount"]);
          }
        });

        this.setDiscountsNuevo(Helpers.precise_round(discount, 2));

        var bookPrice =
          this.defaultSection.book_purchase == 1 &&
          this.defaultSection.book.book_price != null
            ? this.defaultSection.book.book_price
            : 0;
        var coursePrice = this.defaultSection.course_amount;

        total = Helpers.precise_round(
          Number(coursePrice) + Number(bookPrice) - Number(this.grossDiscount),
          2
        );

        this.setTotalToPay(total);
      }
    },
    courseDiscounts() {
      let list = [],
        discounts = [];

      discounts = this.selectedDiscounts;

      if (discounts) {
        discounts.forEach(element => {
          if (
            element.status &&
            element.item == "DERECHOENSEÑANZA" &&
            element.quotas_payment == "AMBOS"
          ) {
            list.push(element);
          }
        });
      }
      return list;
    }
  },
  watch: {
    feeSwitch: function(value) {
      let discounts = this.selectedDiscounts;

      if (this.feeSwitch) {
        discounts.forEach(element => {
          if (element["quotas_payment"] == "NO") {
            element["status"] = false;
          }
        });

        this.loadFee();
      } else {
        this.radios = null;
        this.feeQty = 0;

        discounts.forEach(element => {
          if (element["quotas_payment"] == "NO") {
            element["status"] = true;
          }
        });
      }
      this.setDiscountsList(discounts);

      //this.addPropToDefaultSection({discount_summary: discounts});

      this.calculeTotalAmount();

      if (this.radios == "radio-1") {
        this.radios = null;
        this.feeQty = 0;
      }
    },
    invoiceSwitch: function(value) {
      if (this.radios == "radio-1") {
        this.radios = null;
      }
    },
    radios: async function() {
      if (this.radios == "radio-1") {
        this.prepareCardPayment();
      } else {
        this.loading = false;
      }
    },
    feeList: function(val) {},
    calcularMonto: function(val) {
      this.feeSwitch = false;
    },
    compraLibro: function(val) {
      this.feeSwitch = false;
    }
  },
  computed: {
    ...mapState([
      "secretKeyJwt",
      "statusCourse",
      "defaultSection",
      "tokenPayzen",
      "bankPay"
    ]),
    ...mapGetters({
      selectedDiscounts: "selectedDiscounts",
      grossDiscount: "grossDiscount",
      totaToPay: "totaToPay",
      selectedBookDiscount: "selectedBookDiscount",
      selectedCourseDiscount: "selectedCourseDiscount",
      selectedAddtional: "selectedAddtional"
    }),
    getMainDiscount() {
      if (this.defaultSection) {
        if (this.defaultSection.discounts) {
          let i = -1;
          for (
            let index = 0;
            index < this.defaultSection.discounts.length;
            index++
          ) {
            if (this.defaultSection.discounts[index].discount_main) {
              i = index;
            }
          }
          if (i > -1) {
            return `${this.defaultSection.discounts[i].discount_name} (${this.defaultSection.discounts[i].discount_percentage}%)`;
          } else return "";
        } else return "";
      } else return "";
    },
    calcularMonto() {
      return this.defaultSection.course_amount;
    },
    compraLibro() {
      return this.defaultSection.book_purchase;
    },
    hasDiscounts() {
      if (
        this.defaultSection.discounts ||
        this.defaultSection.other_discounts
      ) {
        return true;
      } else return false;
    },
    onlyQuota() {
      if (
        this.defaultSection.quotas &&
        this.defaultSection.quotas.length <= 1
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>
<style lang="scss">
.discount_name_2 {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  text-align: left;
  padding-top: 5px;
}
.discount_value {
  text-align: right;
}
.discount_remove {
  text-decoration: line-through;
  color: #ff5449;
}
.dialog_text {
  font-size: 15px;
  line-height: 18px;
  color: #41424e;
  padding-bottom: 50px !important;
  text-align: center;
}
</style>
